import React from 'react';
import ResetPassword from '../../@jumbo/components/Common/authComponents/ResetPassword';

const ResetPasswordPage = () => <ResetPassword variant="standard" wrapperVariant="bgColor" />;

export default ResetPasswordPage;
